// extracted by mini-css-extract-plugin
export default {"flexContainer":"SearchTitle_flexContainer__kG0KE","title":"SearchTitle_title__NgRqF"};